<template>
  <Row justify="center" class="code-row-bg ivu-text-center ivu-mt-16">
    <Col span="24">
      <Page
        :total="total"
        show-total
        show-elevator
        show-sizer
        :current.sync="currentPage"
        :page-size.sync="pageSizeLocal"
        @on-change="handleChange"
        @on-page-size-change="handleSizeChange"
      />
    </Col>
  </Row>
</template>

<script>
export default {
  name: 'CommonPage',
  props: {
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      // 定义本地数据，初始值从 prop 同步
      currentPage: this.current,
      pageSizeLocal: this.pageSize
    }
  },
  watch: {
    // 监听父组件传入的 current 变化，同步到本地 currentPage
    current(newVal) {
      this.currentPage = newVal;
    },
    // 监听父组件传入的 pageSize 变化，同步到本地 pageSizeLocal
    pageSize(newVal) {
      this.pageSizeLocal = newVal;
    },
    // 监听本地 currentPage 变化，触发事件通知父组件
    currentPage(newVal) {
      this.$emit('update:current', newVal);
      this.$emit('on-change', newVal);
    },
    // 监听本地 pageSizeLocal 变化，触发事件通知父组件
    pageSizeLocal(newVal) {
      this.$emit('update:pageSize', newVal);
      this.$emit('on-page-size-change', newVal);
    }
  },
  methods: {
    handleChange(page) {
      this.currentPage = page;
    },
    handleSizeChange(size) {
      this.pageSizeLocal = size;
    }
  }
}
</script>